import {
  _allProgramsDataSuccess,
  _getTutorData,
  _setProgramName,
  _setAttendanceData,
  _postAttendance,
  _getAllChaptersOfProgram,
  _getTopicsFortheChapters,
  _addTopic,
  _addPlanner,
  _getPlanners,
  _getClassStartTime,
} from "./types";

import { getBaseUrl, getNestUrl } from "./utility";

import axios from "axios";

var token = localStorage.getItem("loginToken");

const instance = axios.create({
  baseURL: getBaseUrl() + "/",
});

const nestInstance = axios.create({
  baseURL: getNestUrl() + "/",
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// Configure the provider with the necessary options.
// const options = {
// 	token: 'abc',
// 	headers: {
// 		'Content-Type': 'application/json'
// 	}
// };
// const options = {};
// instance.interceptors.request.use(tokenProvider(options));

export const getAllPrograms = (std_ids) => async (dispatch) => {
  var bodyFormData = new FormData();
  bodyFormData.set("grade_students", JSON.stringify(std_ids));

  // console.log(std_ids);

  instance
    .post("/api/v1/grade/progs", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _allProgramsDataSuccess,
          payload: res.data,
        });
      } else {
        if (res.data.status == "error") {
          dispatch({
            type: _allProgramsDataSuccess,
            payload: res.data,
          });
        } else {
          dispatch({
            type: _allProgramsDataSuccess,
            payload: res.data,
          });
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      dispatch({
        type: _allProgramsDataSuccess,
        payload: "error",
      });
    });
};

export const getTutorData = (data) => async (dispatch) => {
  dispatch({
    type: _getTutorData,
    payload: data,
  });
};

export const submitAttendance =
  (client_id, teacher_id, prog_id, attendance_data, slot_id) =>
  async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("client_id", client_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("attendance_data", JSON.stringify(attendance_data));
    return instance
      .post("/api/v1/student/attendance", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          // if success only
          dispatch({
            type: _postAttendance,
            payload: { prog_id, attendance_data, slot_id },
          });
          return res;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const setProgramName = (data) => async (dispatch) => {
  dispatch({
    type: _setProgramName,
    payload: data,
  });
};

export const getAttendance = (user_id, clientId) => async (dispatch) => {
  return instance
    .get(
      `/api/v1/students/attendance/fetch?teacher_id=${user_id}&client_id=${clientId}`,
      {
        headers: {
          "Content-Type": "application/JSON",
        },
      }
    )
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        dispatch({
          type: _setAttendanceData,
          payload: res.data,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const submitEvaluationReport =
  (client_id, teacher_id, prog_id, prog_name, evaluationData, slotId, date) =>
  async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("client_id", client_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("prog_name", prog_name);
    bodyFormData.set("slot_id", slotId);
    bodyFormData.set("date", date);
    bodyFormData.set("evaluationData", JSON.stringify(evaluationData));
    bodyFormData.set("is_dev", 0); //Send is_dev = 1 to not send whatsapp message to parent
    return instance
      .post("/api/v1/students/attendance/update", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _ownLead,
          //   payload: lead_id,
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

//planner Actions

export const getAllChapters = (prog_id) => async (dispatch) => {
  debugger;
  var bodyFormData = new FormData();
  bodyFormData.set("prog_id", prog_id);
  bodyFormData.set("req_type", 0);
  return instance
    .post("/api/v1/planner/program/details", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        debugger;
        // if success only
        dispatch({
          type: _getAllChaptersOfProgram,
          payload: res.data.result,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          debugger;
          dispatch({
            type: _getAllChaptersOfProgram,
            payload: [],
          });
        } else {
          dispatch({
            type: _getAllChaptersOfProgram,
            payload: [],
          });
        }
      }
    })
    .catch((error) => {
      debugger;
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const getTopicForChapters =
  (prog_id, assessment_id) => async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("req_type", 1);
    bodyFormData.set("assessment_id", assessment_id);
    return instance
      .post("/api/v1/planner/program/details", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          dispatch({
            type: _getTopicsFortheChapters,
            payload: res.data.result,
          });
          return res;
        } else {
          if (res.data.status == "error") {
            debugger;
            dispatch({
              type: _getTopicsFortheChapters,
              payload: res.data,
            });
          } else {
            dispatch({
              type: _getTopicsFortheChapters,
              payload: res.data,
            });
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const addTopic = (data, id) => async (dispatch) => {
  debugger;
  dispatch({
    type: _addTopic,
    payload: data,
    id: id,
  });
};

export const submitPlanner =
  (client_id, teacher_id, prog_id, month, year, plannerData, slot_id) =>
  async (dispatch) => {
    var bodyFormData = new FormData();
    bodyFormData.set("client_id", client_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("month", month);
    bodyFormData.set("year", year);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("week_data", JSON.stringify(plannerData));
    return instance
      .post("/api/v1/planner/create", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          // 	type: _addPlanner,
          // 	payload: { prog_id, attendance_data },
          // });
          return res;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          } else {
            // dispatch({
            // 	type: _allProgramsDataSuccess,
            // 	payload: res.data
            // })
          }
        }
        return res;
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const getPlanners = (user_id, clientId) => async (dispatch) => {
  return instance
    .get(
      `/api/v1/planner/archives?teacher_id=${user_id}&client_id=${clientId}`,
      {
        headers: {
          "Content-Type": "application/JSON",
        },
      }
    )
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        debugger;
        // if success only
        dispatch({
          type: _getPlanners,
          payload: res.data,
        });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
      return res;
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const getClassStartTime =
  (prog_id, user_id, course_id, client_id, slot_id, month, year) =>
  async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", user_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("client_id", client_id);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("month", month);
    bodyFormData.set("year", year);
    return instance
      .post("/api/v1/user/feed/timetable", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };
export const sendStartTime =
  (prog_id, user_id, course_id, slot_id, planner_id, planner_topic) =>
  async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", user_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("planner_id", planner_id);
    bodyFormData.set("planner_topic", JSON.stringify(planner_topic));
    return instance
      .post("/api/v1/user/feed/starttimestamp", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const getClassSummary =
  (prog_id, user_id, course_id, filter, slot_id) => async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", user_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("filter", filter);
    bodyFormData.set("slot_id", slot_id);
    return instance
      .post("/api/v1/user/feed/gettimestarthistory", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const sendActions =
  (prog_id, user_id, course_id, time_id, label) => async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", user_id);
    bodyFormData.set("time_id", time_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("label", label);
    return instance
      .post("/api/v1/user/feed/takeaction", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const submitZoomLinkForClassStart =
  (prog_id, user_id, course_id, zoomlink, slot_id) => async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", user_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("zoomlink", zoomlink);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("client_id", 2);
    return instance
      .post("/api/v1/user/feed/updatezoomlink", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const getAvailability = (teacherId) => async (dispatch) => {
  return instance
    .get(`/api/v1/lead/getavailableclassrequests?teacher_id=${teacherId}`, {
      headers: {
        "Content-Type": "application/JSON",
      },
    })
    .then((res) => {
      // console.log(res);
      if (res.data.status == "success") {
        // if success only
        // dispatch({
        // 	type: _setAttendanceData,
        // 	payload: res.data,
        // });
        return res;
      } else {
        if (res.data.status == "error") {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        } else {
          // dispatch({
          // 	type: _allProgramsDataSuccess,
          // 	payload: res.data
          // })
        }
      }
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const submitAvailability =
  (lead_id, teacher_id, class_request_id) => async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("lead_id", lead_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("class_request_id", class_request_id);
    bodyFormData.set("client_id", 2);
    return instance
      .post("/api/v1/lead/teachershowinterest", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const submitDemoStudentFeedback =
  (student_id, teacher_id, course_id, prog_id, feedback_data) =>
  async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("student_id", student_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("feedback_data", JSON.stringify(feedback_data));
    bodyFormData.set("client_id", 2);
    return instance
      .post("/api/v1/send/demo/student/feedback", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const submitClassCancelReasons =
  (prog_id, teacher_id, reasons, students, course_id) => async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("students", JSON.stringify(students));
    bodyFormData.set("reasons", JSON.stringify(reasons));
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("client_id", 2);
    return instance
      .post("/api/v1/cancelclassbyteacher", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };

export const sendPlannerDataToFeed =
  (prog_id, user_id, course_id, slot_id, planner_id, planner_topic) =>
  async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", user_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("planner_id", planner_id);
    bodyFormData.set("planner_topic", JSON.stringify(planner_topic));
    return instance
      .post("/api/v1/user/feed/sendplannerdata", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };
export const uploadVideoinTopics =
  (assess_id, test_id, video_caption, video_url, teacher_id, videoId) =>
  async (dispatch) => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("assess_id", assess_id);
    bodyFormData.set("test_id", test_id);
    bodyFormData.set("video_caption", video_caption);
    bodyFormData.set("video_url", video_url);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("video_id", videoId);
    return instance
      .post("/api/v1/addtopicvideo", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;
          // if success only
          // dispatch({
          //   type: _getClassStartTime,
          //   payload: res.data.result,
          // });
          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
            return res.data;
          } else {
            // dispatch({
            // 	type: _getClassStartTime,
            // 	payload: res.data
            // })
          }
        }
      })
      .catch((error) => {
        debugger;
        // console.log(error);
        // dispatch({
        // 	type: _allProgramsDataSuccess,
        // 	payload: "error"
        // })
      });
  };
export const updatePlannerDataFunc =
  (
    prog_id,
    teacher_id,
    course_id,
    slot_id,
    planner_id,
    feed_date,
    planner_topic
  ) =>
  async () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.set("prog_id", prog_id);
    bodyFormData.set("teacher_id", teacher_id);
    bodyFormData.set("course_id", course_id);
    bodyFormData.set("slot_id", slot_id);
    bodyFormData.set("planner_id", planner_id);
    bodyFormData.set("feed_date", feed_date);
    bodyFormData.set("planner_topic", planner_topic);
    return instance
      .post("/api/v1/user/feed/updateplannerdata", bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.data.status == "success") {
          debugger;

          return res.data;
        } else {
          if (res.data.status == "error") {
            debugger;

            return res.data;
          } else {
          }
        }
      })
      .catch((error) => {
        debugger;
      });
  };
export const updateTimeTable = (teacher_id, slot_id, timeTable) => async () => {
  debugger;
  var bodyFormData = new FormData();
  bodyFormData.set("timetable", timeTable);
  bodyFormData.set("teacher_id", teacher_id);
  bodyFormData.set("slot_id", slot_id);
  return instance
    .post("/api/v1/timetableupdate", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        debugger;

        return res.data;
      } else {
        if (res.data.status == "error") {
          debugger;

          return res.data;
        } else {
        }
      }
    })
    .catch((error) => {
      debugger;
    });
};

export const updatePlannerEndpoint = (planner_id, val) => async () => {
  debugger;
  var bodyFormData = new FormData();
  bodyFormData.set("planner_id", planner_id);
  bodyFormData.set("col", "week_data");
  bodyFormData.set("val", JSON.stringify(val));
  return instance
    .post("/api/v1/planner/update", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log(res);
      if (res.data.status == "success") {
        debugger;

        return res.data;
      } else {
        if (res.data.status == "error") {
          debugger;

          return res.data;
        } else {
        }
      }
    })
    .catch((error) => {
      debugger;
    });
};

export const getNewTeacher = (teacherId, accessToken) => {
  return nestInstance
    .get(`/teacher/${teacherId}/recruitment?client_id=2`, {
      headers: {
        "Content-Type": "application/JSON",
        // Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      // console.log(error);
      // dispatch({
      // 	type: _allProgramsDataSuccess,
      // 	payload: "error"
      // })
    });
};

export const teacherForm = (
  teacher_id,
  recruitment_id,
  question,
  answer,
  question_type
) => {
  const bodyconfig = {
    teacher_id,
    recruitment_id,
    question,
    answer,
    question_type,
  };

  let res = {};
  return nestInstance
    .post("/teacher/form?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return error;
    });
};

export const teacherProfileUpdate = (
  name,
  email,
  phoneNumber,
  gender,
  dob,
  teacher_id
) => {
  const bodyconfig = {
    name,
    email,
    phoneNumber,
    gender,
    dob,
    teacher_id,
  };

  let res = {};
  return nestInstance
    .post("/teacher/profile?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return res;
    });
};

export const teacherFormSubmit = (teacher_id, recruitment_id) => {
  const bodyconfig = {
    teacher_id,
    recruitment_id,
  };

  let res = {};
  return nestInstance
    .post("/teacher/form-submit?client_id=2", bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return res;
    });
};

export const teacherStatusUpdate = (status, id) => {
  const bodyconfig = {
    status,
  };

  let res = {};
  return nestInstance
    .patch(`/admin/teacher/recruitment/${id}?client_id=2`, bodyconfig, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      res = response;
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return res;
    });
};

export const getTutorsFeed = (tutorId, limit) => {
  let res = {};
  return nestInstance
    .get(
      `/teacher/feed?client_id=2&teacher_id=${tutorId}&take=${limit}&skip=0`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then(function (response) {
      res = response;
      return res;
    })
    .catch(function (error) {
      res = error.response;
      console.log(error);
      return res;
    });
};
